import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AuthService } from 'src/services/auth/auth.service';
import { UserService } from 'src/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(public authService: AuthService, public router: Router, private jwtHelper: JwtHelperService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (!this.jwtHelper.tokenGetter()) {
        this.router.navigate(['/login'], { queryParams: { next: state.url }});
        return false;
      } else if (!this.authService.isAuthenticated() && !state.url) {
        this.router.navigate(['/']);
        return false;
      } else if (!this.authService.isAuthenticated()) {

        this.router.navigate(['/']);
        return false;
      }
      return true;
  }
  
}
